export default "__VITE_ASSET__BJCJg4EW__"